export default __webpack_public_path__ + "static/media/authImg.a0e443eb.png";